let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("av3G4")).then(() => parcelRequire('ljBNj'));